export enum TableColumnType {
    Default,
    Boolean,
    DateTime,
    Date,
    Time,
    TimeAgo,
}
